export default `vec4 p = vec4(p0, 1.);
    for(int i = 0; i < 8; i++){
      if(p.x > p.z)p.xz = p.zx;
      if(p.z > p.y)p.zy = p.yz;
      p = abs(p);
      p.xyz = mod(p.xyz-1., 2.)-1.;
      p*=1.23;
    }
    p/=p.w;
    return abs(p.y)*0.25;
  }`